/**
 * Выбирает существительное с верным окончанием в зависимости от предшествующего числительного.
 * 
 * @param num Числительное.
 * @param t1 Вариант для числительных, оканчивающихся на 1.
 * @param t2 Вариант для числительных, оканчивающихся на 2, 3 или 4.
 * @param t3 Вариант для остальных числительных.
 * @returns Существительное с верным окончанием.
 */
function pluralNumber (
	num: number,
	t1: string,
	t2: string,
	t3: string
): string
{
	let t = '';

	if ( num > 99 )
	{
		num = num % 100;
	}
	
	if ( num === 11 || num === 12 || num === 13 || num === 14 )
	{
		return t3;
	}

	switch ( num % 10 )
	{
		case 1: 
			t = t1;
			break;
		case 2: 
		case 3:
		case 4:
			t = t2;
			break;
		default: 
			t = t3;
		
	}
	
	return t;
}

/**
 * Module.
 */
export {
	pluralNumber as default,
};


// WEBPACK FOOTER //
// ./app/utils/pluralNumber.ts